import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

import { ROUTES } from "../../constants/routes";
import logo from "../../assets/images/logoAleanteHeader.svg";

import "../../styles/components/Header.scss";

export default function Header() {
  return (
    <Navbar
      className="navmenu scroll px-3"
      expand="md"
      variant="dark"
      sticky="top"
      collapseOnSelect
    >
      <Container fluid>
        <Navbar.Brand as={Link} to={ROUTES.ROOT}>
          <img src={logo} className='logo' alt="Logo laboratorio" />
        </Navbar.Brand>
        <Navbar.Toggle/>
        <Navbar.Collapse className="justify-content-end">
          <Nav className="navmenu__nav-items">
            <Nav.Link as={NavLink} to={ROUTES.ROOT}>
              Inicio
            </Nav.Link>
            <Nav.Link as={NavLink} to={ROUTES.TEAMWORK}>
              Equipo
            </Nav.Link>
            <Nav.Link as={NavLink} to={ROUTES.OFERTA}>
              Oferta de trabajo
            </Nav.Link>
            {/* <Nav.Link as={NavLink} to={ROUTES.CONTACTO}>
              Contacto
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
